import {pluralize} from "@pg-mono/string-utils";

export const flatsPluralize = pluralize(["mieszkanie", "mieszkania", "mieszkań"]);
